import Button from "@mui/material/Button";
import {tableControlStyle} from "../TableControls";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import {Fragment, useState} from "react";
import React from "react";
import Typography from "@mui/material/Typography";


const FullScreenButton = ({fullScreenHandle}) => {
    const [isFullscreen, setIsFullscreen] = useState(false); // Initial state
    return <Fragment>
        <Button
            onClick={
            async () => {
                // Use DOM state rather than handle.active. handle.active can be
                // spuriously true when the FullScreen div is unmounted while a
                // fullscreenchange event fires: null===null evaluates to true,
                // making unmounted handles appear active. Checking the DOM
                // directly is always correct regardless of mount state.
                const actuallyFullscreen =
                    !!fullScreenHandle.node.current &&
                    document.fullscreenElement === fullScreenHandle.node.current;
                await (actuallyFullscreen ? fullScreenHandle.exit() : fullScreenHandle.enter());
                let nowIsFullScreen = !isFullscreen;

                setIsFullscreen(nowIsFullScreen)
            }
            } startIcon={<FullscreenIcon />} sx={tableControlStyle} >
            <Typography style={{
                textDecoration: isFullscreen ? 'underline' : 'none' ,
                color: isFullscreen ? '#1876D2' : "black"
            }}>Fullscreen</Typography>
        </Button>
    </Fragment>
};

export default FullScreenButton;